<template>
  <a-drawer
    :title="title"
    :visible="visibleField"
    :width="900"
    :maskClosable="true"
    :destroyOnClose="true"
    placement="right"
    style="overflow: auto; padding-bottom: 53px"
    @close="handleCancel"
  >
    <a-spin :spinning="confirmLoading">
      <div>
        <a-form :form="form" @keyup.enter.native="searchQuery">
          <div class="dynamic-wrap">
            <div v-for="(pre, index) in headFiled" :key="pre.tableHeadId">
              <a-row :gutter="24">
                <a-col :span="6">
                  <a-form-item
                    :labelCol="{ span: 7 }"
                    :wrapperCol="{ span: 17 }"
                  >
                    <a-select
                      style="width: 200px"
                      placeholder="请选择表头字段"
                      v-decorator="[
                        `tableHeadId[${index}]`,
                        {
                          rules: [{ required: true, message: '请选择对比项!' }]
                        }
                      ]"
                    >
                      <a-select-option
                        v-for="item in fieldArr"
                        :key="item.tableHeadFieldId"
                      >
                        {{ item.tableHeadFieldName }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-form-item
                    :labelCol="{ span: 6 }"
                    :wrapperCol="{ span: 18 }"
                  >
                    <a-input
                      v-decorator="[
                        `showName[${index}]`,
                        {
                          rules: [{ required: true, message: '请输入显示名称' }]
                        }
                      ]"
                      placeholder="请输入显示名称"
                    ></a-input>
                  </a-form-item>
                </a-col>
                <a-col :span="3">
                  <a-form-item>
                    <a-switch
                      v-decorator="[
                        `status[${index}]`,

                        { initialValue: false, valuePropName: 'checked' }
                      ]"
                      checked-children="启用"
                      un-checked-children="关闭"
                    />
                  </a-form-item>
                </a-col>
                <a-col :span="2" style="padding-left: 0px">
                  <a-form-item
                    :labelCol="{ span: 0 }"
                    :wrapperCol="{ span: 24 }"
                  >
                    <template v-if="headFiled.length > 1">
                      <a-icon
                        type="delete"
                        @click="handleRemove(pre.tableHeadId)"
                      />
                    </template>
                  </a-form-item>
                </a-col>
              </a-row>
            </div>
          </div>
        </a-form>

        <a-button class="fieldBtn" @click="addField">+</a-button>
      </div>
    </a-spin>
    <div class="drawer-bootom-button">
      <a-popconfirm
        title="确定放弃编辑？"
        @confirm="handleCancel"
        okText="确定"
        cancelText="取消"
      >
        <a-button style="margin-right: 0.8rem">取消</a-button>
      </a-popconfirm>
      <a-button @click="handleOk" type="primary">提交</a-button>
    </div>
  </a-drawer>
</template>

<script>
import {
  getAllTableHeadData,
  addTableHeaderToProductGroup,
  getTableHeadByGroupId
} from '@/api/product';

export default {
  name: 'FieldModal',

  data() {
    return {
      form: this.$form.createForm(this, { name: 'coordinated' }),
      confirmLoading: false,
      visibleField: false,
      title: '表头字段',
      fieldArr: [],
      headFiled: [],
      fundGroupId: ''
    };
  },
  mounted() {
    this.getHeadData();
  },
  methods: {
    //获取表头信息回显
    getFieldInfo() {
      let params = `?groupId=${this.fundGroupId}`;
      getTableHeadByGroupId(params).then(res => {
        if (res.success) {
          let headIdArr = [];
          let nameArr = [];
          let statusArr = [];
          if (res.result && res.result.length > 0) {
            res.result.map((item, index) => {
              headIdArr.push(item.tableHeadId);
              nameArr.push(item.showName);
              item.status = item.status == 0 ? false : true;
              statusArr.push(item.status);
              //分组名称回显
            });
            this.$nextTick(() => {
              setTimeout(() => {
                this.form.setFieldsValue({
                  tableHeadId: headIdArr,
                  showName: nameArr,
                  status: statusArr
                });
              }, 300);
            });
          } else {
            this.headFiled = [{}];
          }
          this.headFiled = res.result;
        }
      });
    },
    //获取表投字段
    getHeadData() {
      getAllTableHeadData().then(res => {
        if (res.success) {
          this.fieldArr = res.result ? res.result : [];
        }
      });
    },
    //编辑回显
    edit(records) {
      console.log(records);
      this.visibleField = true;
    },
    //添加表头字段展示
    addField() {
      this.headFiled.push({ status: false });
    },
    // 删除一行
    handleRemove(id) {
      let index = this.headFiled.findIndex(item => item.tableHeadId == id);
      this.headFiled.splice(index, 1);
      let headIdArr = [];
      let nameArr = [];
      let statusArr = [];
      this.headFiled.map((item, index) => {
        headIdArr.push(item.tableHeadId);
        nameArr.push(item.showName);
        item.status = item.status == 0 ? false : true;
        statusArr.push(item.status);
        //分组名称回显
      });
      this.$nextTick(() => {
        setTimeout(() => {
          this.form.setFieldsValue({
            tableHeadId: headIdArr,
            showName: nameArr,
            status: statusArr
          });
        }, 300);
      });
    },

    handleFieldVisible(record) {
      this.visibleField = true;
      console.warn(record);
      this.fundGroupId = record.id;
      this.$nextTick(() => {
        this.getFieldInfo();
      });
    },
    handleCancel() {
      this.$emit('close');
      this.visibleField = false;
    },
    handleOk() {
      this.form.validateFields((err, values) => {
        if (!err) {
          let fieldArr = [];
          values.showName.map((item, index) => {
            fieldArr.push({
              sort: index + 1,
              showName: item,
              status: values.status[index] == true ? 1 : 0,
              tableHeadId: values.tableHeadId[index]
            });
          });
          let params = {
            fundGroupId: this.fundGroupId,
            tableHeadParamDTOList: fieldArr
          };
          addTableHeaderToProductGroup(params).then(res => {
            if (res.success) {
              console.log(res);
              this.$message.success('操作成功');
              this.visibleField = false;
              this.$emit('initProductList', '1');
            } else {
              this.$message.error(res.message);
            }
          });
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.fieldBtn {
  padding: 0 40px;
}
.drawer-bootom-button {
  position: absolute;
  bottom: -8px;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  left: 0;
  background: #fff;
  border-radius: 0 0 2px 2px;
}
</style>
